/*
Aca llega al click en la tarjeta de consignaciones cuando está
creando una liquidación.
Obtiene la consignacion, y dos datos esenciales: los id del cliente
y del vehiculo
*/
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { useConsignmentFetcher } from '../hooks/useConsignmentFetcher'
import { useAuth } from '../hooks/useAuth'
import { AppPath } from '../enums/AppPath'

const SettlementConsignment: React.FC = () => {
  const { errorConsignment, fetchConsignmentDtoWithId } = useConsignmentFetcher()
  const [errorMessage, setErrorMessage] = useState<string>('')

  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const { setSelectedPair } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const fetchDataAsync = async () => {
      if (!id || id === '') {
        setErrorMessage('ID is not defined.')

        return // Exit early if `id` is undefined
      }

      const consignment = await fetchConsignmentDtoWithId(id)

      if (errorConsignment) {
        setErrorMessage(errorConsignment.message)

        return
      }

      if (!consignment) {
        setErrorMessage('Error al recuperar clientId')

        return
      }

      const clientId = consignment?.client
      const vehicleId = consignment?.vehicle

      // Nos vamos a la que crea:
      setSelectedPair({ clientId: clientId, vehicleId: vehicleId, consignment: consignment })

      const url = `/selection/${AppPath.Settlements}`
      navigate(url)
    }

    fetchDataAsync()
  }, [id])

  return <>{errorMessage}</>
}
export default SettlementConsignment
